<template>
  <div>
    <div class="mb-5" v-if="!setting.templates.avatar || !setting.templates.description">
      <a-alert type="warning" show-icon >
        <template slot="message">
          Please Enter description and avatar bill in part <strong>Settings > WEB SETTING > Billing</strong>.
          <a-button type="link" class="p-0" @click="goToRouterAccountOrBilling('billing')">Go to page</a-button>
        </template>
      </a-alert>
    </div>
    <div class="mb-5" v-if="!setting.accounts">
      <a-alert type="warning" show-icon >
        <template slot="message">
          Please Enter Information account company bill in part <strong>Settings > SYSTEM > Account</strong>.
          <a-button type="link" class="p-0" @click="goToRouterAccountOrBilling('account')">Go to page</a-button>
        </template>
      </a-alert>
    </div>
  </div>
</template>

<script>
export default {
  name: "AlertTemplate",
  props:{
    setting:{
      type:Object
    }
  },
  methods:{
    goToRouterAccountOrBilling(query){
      this.$router.push({ path: '/settings', query: { setting: query }})
    }
  }
}
</script>

